<div id="generated-qr-code">
</div>
@if (checkPermission('patient_print_QRcode')) {
  <div class="qr-code-btn">
    <button type="button" class="btn btn-primary" (click)="qrcodeprint()">Print</button>
  </div>
}